export const ROUTE_NAME = {
  NAME: '/tiep-nhan-ho-so/',
  HS_TRUC_TIEP: {
    NAME: 'truc-tiep',
    DANH_SACH: 'tiep-nhan-ho-so-truc-tiep',
    CHI_TIET: 'chi-tiet/:id',
    CAP_NHAT: 'cap-nhat/:id',
  },
  HS_TRUC_TUYEN: {
    NAME: 'hs-truc-tuyen',
    DS: 'tiep-nhan-ho-so-truc-tuyen',
    CT: 'ct-ds-tt',
  },
  TN_BO_SUNG: {
    NAME: 'tn-bo-sung',
    DS_BS: 'tiep-nhan-ho-so-bo-sung',
    CT_BS: 'ct-hs-bo-sung',
  },
  THEM_MOI: 'them-moi',
}

export const MENU_ROUTE_NAME = {
  NAME: 'Tiếp nhận hồ sơ',
  HS_TRUC_TIEP: 'Hồ sơ tiếp nhận trực tiếp',
  HS_TRUC_TUYEN: 'Hồ sơ tiếp nhận trực tuyến',
  TN_BO_SUNG: 'Tiếp nhận bổ sung',
  CT_BS: 'Chi tiết hồ sơ bổ sung',
  CHI_TIET_HO_SO: 'Chi tiết hồ sơ',
  THEM_MOI: 'Thêm mới',
  CAP_NHAT: 'Cập nhật',
}
